<template>
  <div class="input-check">
    <input
      class="input-check__item"
      type="checkbox"
      :id="id"
      :name="name"
      :value="value"
      :required="isRequired"
    />
    <label class="input-check__label" :for="id">
      {{ $t("configSite.termsAndConditions.text") }}
      <span>{{ $t("configSite.termsAndConditions.textSecondary") }}</span>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      default: "",
    },
    isRequired: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.input-check {
  position: relative;
  display: flex;
  gap: 20px;
  margin: 30px 0;
  &__label {
    width: calc(100% - 55px);
    font-size: 14px;
    font-family: "Font Regular";
    color: var(--color-black-light);
    margin-bottom: 0;
    cursor: pointer;
    span {
      display: block;
      margin-top: 20px;
    }
    @media (max-width: 991px) {
      font-size: 12px;
    }
  }
  input[type="checkbox"]:checked:before {
    content: "";
    transform: translate(-50%, -50%) scale(1);
    opacity: 1;
    width: 15px;
    height: 15px;
    background: var(--color-green);
    border-radius: 100%;
    @media (max-width: 991px) {
      width: 10px;
      height: 10px;
    }
  }

  input[type="checkbox"]:before {
    content: "";
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%) scale(0);
    opacity: 0;
    border: 0;
  }

  input[type="checkbox"] {
    position: relative;
    width: 35px;
    height: 35px;
    background: var(--white);
    border: 1px solid var(--color-gray-2);
    border-radius: 10px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    outline: 0 !important;
    margin: 0;
    cursor: pointer;
    @media (max-width: 991px) {
      width: 25px;
      height: 25px;
      border-radius: 5px;
    }
  }
}
</style>
